// @flow

type Logger = (...args: Array<mixed>) => void

let log: Logger = () => {}

export const setP2PLogger = (logger: Logger) => {
  log = logger
}

export const p2pLog: Logger = (...args) => log(...args)
